/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetGposMutationResponse,
  PerformSetGposPathParams,
  PerformSetGpos404,
} from '../types/PerformSetGpos'

function getPerformSetGposUrl({
  import_number,
}: {
  import_number: PerformSetGposPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-gpos/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-GPOs step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-gpos/}
 */
export async function performSetGpos(
  {
    import_number,
  }: { import_number: PerformSetGposPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PerformSetGposMutationResponse,
    ResponseErrorConfig<PerformSetGpos404>,
    unknown
  >({
    method: 'POST',
    url: getPerformSetGposUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
